export class PrescriptionDrugStockValidation {
  constructor() {}

  public inventoryDetailId?: string;
  public stockId?: string;
  public drugId?: string;
  public brandName?: string;
  public drugPackage?: string;
  public expireDate?: string;
  public stockName?: string;
  public inventoryCount?: string;
  public saleCount?: string;
  public price?: string;
  public patientSharePrice?: string;
  public governmentSharePrice?: string;
  public insuranceSharePrice?: string;
  public genericCode?: string;
  public genericName?: string;
}
